import CompareAllFilters from 'filters/compare-all-filters';
import {setUpgradeSkillsInclusion} from 'sales/upgrade';

window.compare = function () {
    function pageBodyLoad() {
        checkUserStatus();
        setResizeEvent();
        setScrollEvent();
        updatePageTitle();
    }

    function setScrollEvent() {
        document.addEventListener("scroll", function () {
            configureSectionNavigation();
        }, false);
    }

    function setResizeEvent() {
        window.addEventListener("resize", function () {
            configureSectionNavigation();
        }, false);
    }

    function configureSectionNavigation() {
        setActiveSection();
    }

    function setActiveSection() {
        let sections, activeSection, activeSectionElement;
        sections = document.querySelectorAll(".subsection[data-section]");
        if (sections) {
            // Filter to discount elements beyond the top third of the screen, sort by closest position to top of screen. Take the top results section
            activeSection = Array.from(sections).filter(el => el.getBoundingClientRect().top < window.innerHeight * 0.3).sort((a, b) => { if (Math.abs(a.getBoundingClientRect().top) > Math.abs(b.getBoundingClientRect().top)) { return 1; } else if (Math.abs(a.getBoundingClientRect().top) < Math.abs(b.getBoundingClientRect().top)) { return -1; } else { return 0; }}).map(el => el.dataset.section)[0];
            if (activeSectionElement = document.querySelector(".sectionActive")) {
                activeSectionElement.classList.remove("sectionActive"); // Remove class from existing
            }
            if (activeSection) {
                document.querySelector(`.sectionElement[data-section='${activeSection}']`).classList.add("sectionActive");
            } else if (document.getElementById("sectionsList").firstChild) {
                document.getElementById("sectionsList").firstChild.classList.add("sectionActive");
            }
        }
    }

    function positionSectionNavigation() {
        let sectionHolder, listSummaryHolderBounds, pageHeaderBounds, filtersHeaderBounds;
        sectionHolder = document.getElementById("sectionHolder");
        listSummaryHolderBounds = document.getElementById("listSummaryHolder").getBoundingClientRect();
        pageHeaderBounds = document.getElementById("pageHeader").getBoundingClientRect();
        filtersHeaderBounds = document.getElementById("compareTwoFiltersControlsBar").getBoundingClientRect();

        if (filtersHeaderBounds.bottom > 0) {
            sectionHolder.classList.remove("fixed");
            sectionHolder.classList.add("absolute");
        } else {
            sectionHolder.classList.remove("absolute");
            sectionHolder.classList.add("fixed");
            sectionHolder.style.left = `${listSummaryHolderBounds.left - Number(getComputedStyle(sectionHolder).width.replace("px", ""))}px`;
            sectionHolder.style.top = `${(filtersHeaderBounds.bottom > 0) ? filtersHeaderBounds.bottom : pageHeaderBounds.bottom}px`
        }
    }

    // Check the user is logged in
    function checkUserStatus() {
        var xhr = new XMLHttpRequest();

        xhr.addEventListener("load", function (event) {
            var response = JSON.parse(xhr.responseText);
            getUserStatusLoad(response);
        });

        // Define what happens in case of error
        xhr.addEventListener("error", function (event) {
            var response = {
                "logged_in": false,
                "message": "Could not check user status"
            }
            getUserStatusLoad(response);
        });

        // Set up our request
        xhr.open("GET", "../api/user/user_actions.php?action=check_user");

        // The data sent is what the user provided in the form
        xhr.send();
    }

    function getUserStatusLoad(response) {
        // Valid user
        if (response.logged_in == true) {
            coreFunctions.userguidingSetup(response);
            comparison.getAllFilters();
        } else {
            requireLogin();
        }

        const userHasRSICLists = response.user_details.premiumFeatures.includes("rsics");
        if (!userHasRSICLists) {
            document.querySelectorAll(`.filterControl[filtergroup="RSICs"`).forEach(element => element.remove());
        }

        setUpgradeSkillsInclusion();
    }

    function toggleMobileHeaderControls(element) {
        let headerControls = element.closest(".controlsBar");
        if (headerControls) {
            if (headerControls.classList.contains("mobileControlsVisible")) {
                headerControls.classList.remove("mobileControlsVisible");
            } else {
                headerControls.classList.add("mobileControlsVisible");
            }
        }
    }

    class FinancialsBarchart {
        constructor(field, elements, label) {
            this.field = field;
            this.label = label;
            this.elements = elements;
            this.maximum = null;
            this.numberOfTopResultsToShow = 20;
        }

        getMaximumCount() {
            let measuredTotals, projectedTotals;
            measuredTotals = this.elements.filter(element => element.compareOne).map(element => element.compareOne.measuredTotal).concat(this.elements.filter(element => element.compareTwo).map(element => element.compareTwo.measuredTotal));
            projectedTotals = this.elements.filter(element => element.compareOne).map(element => element.compareOne.projectedTotal).concat(this.elements.filter(element => element.compareTwo).map(element => element.compareTwo.projectedTotal));
            this.maximum = Math.max(...measuredTotals.concat(projectedTotals));
            return this;
        }

        createBarchart() {

            let barchartContentWrapper, barchartContent, barchartElementsHolder;

            barchartContentWrapper = coreFunctions.createElementHelper("div", { class: "barchartContentWrapper", id: `${this.field}ChartContentWrapper`, charttype: "bar" });

            barchartContent = coreFunctions.createElementHelper("div", { class: "barchartContent" });
            barchartContentWrapper.appendChild(barchartContent);

            barchartContent.appendChild(this.addFinancialsBarchartKey());

            this.elements.forEach((element) => {
                let barchartFragment, barchartLi, compareOneBarchartElement, compareTwoBarchartElement;
                barchartFragment = document.createDocumentFragment();

                barchartLi = barchartFragment.appendChild(coreFunctions.createElementHelper("li"));
                barchartLi.appendChild(coreFunctions.createElementHelper("span", { class: "barLabel", innerHTML: element.year }));

                if (element.compareOne) {
                    compareOneBarchartElement = element.compareOne.createFinancialsBarchartElement(this.maximum);
                    barchartLi.appendChild(compareOneBarchartElement);
                } else {
                    barchartLi.appendChild(this.createEmptyFinancialsBarchartElement("compareOne"));
                }

                if (element.compareTwo) {
                    compareTwoBarchartElement = element.compareTwo.createFinancialsBarchartElement(this.maximum);
                    barchartLi.appendChild(compareTwoBarchartElement);
                } else {
                    barchartLi.appendChild(this.createEmptyFinancialsBarchartElement("compareTwo"));
                }

                barchartContent.appendChild(barchartFragment);
            });

            document.querySelector(`.barchartHolder[field='${this.field}']`).appendChild(barchartContentWrapper);
            document.querySelector(`.barchartHolder[field='${this.field}'] .widgetTitle`).innerHTML = this.label;
            return this;
        }

        createEmptyFinancialsBarchartElement(comparisonGroup) {
            let barHolder, barContainer;
            barHolder = coreFunctions.createElementHelper("span", { class: "barHolder" });
            barContainer = barHolder.appendChild(coreFunctions.createElementHelper("span", { class: "barContainer", "data-compare_element": comparisonGroup }));
            barContainer.appendChild(coreFunctions.createElementHelper("span", { class: "bar", "data-compare_element": comparisonGroup, style: `width: 0%`, innerHTML: "&nbsp;" })); // Bar
            barHolder.appendChild(coreFunctions.createElementHelper("span", { class: "barCount", innerHTML: "N/A" })); // Count
            return barHolder;
        }

        addFinancialsBarchartKey() {
            let financialsKey, fieldCompanyTotalsHolder, fieldCompanyTotalsCheckbox, fieldCompanyTotalsLabel, fieldCompanyTotals, fieldCompanyCountsHolder;
            financialsKey = coreFunctions.createElementHelper("div", { class: "keyHolder", innerHTML: `<span class='keyElement' data-compare_element='compareOne'><span class='keySquare measured'>&nbsp;</span><span class='keyLabel'><span class='compareGroupTitleElement' data-compare-element='compareOne'>${compare.comparison.compareOne.title}</span> measured</span></span><span class='keyElement' data-compare_element='compareOne'><span class='keySquare projected'>&nbsp;</span><span class='keyLabel'><span class='compareGroupTitleElement' data-compare-element='compareOne'>${compare.comparison.compareOne.title}</span> projected</span></span><span class='keyElement' data-compare_element='compareTwo'><span class='keySquare measured'>&nbsp;</span><span class='keyLabel'><span class='compareGroupTitleElement' data-compare-element='compareTwo'>${compare.comparison.compareTwo.title}</span> measured</span></span><span class='keyElement' data-compare_element='compareTwo'><span class='keySquare projected'>&nbsp;</span><span class='keyLabel'><span class='compareGroupTitleElement' data-compare-element='compareTwo'>${compare.comparison.compareTwo.title}</span> projected</span></span>` });

            return financialsKey;
        }
    }

    class Comparison {
        constructor() {
            this.exploreLists = new ExploreLists();
            this.compareOne = {
                title: "Group 1",
                filters: new CompareAllFilters("compare", "compareOne", "compareOne"),
                filtersLoaded: false,
                analysisLoaded: false,
                analysis: new CompareAnalysis("compareOne", "Group 1", null, 0, "All", "Group 1", "All")
            };
            this.compareTwo = {
                title: "Group 2",
                filters: new CompareAllFilters("compare", "compareTwo", "compareTwo"),
                filtersLoaded: false,
                analysisLoaded: false,
                analysis: new CompareAnalysis("compareTwo", "Group 2", null, 0, "All", "Group 2", "All")
            };
            this.comparisonResults = {
                fields: []
            };
        }

        getAllFilters() {
            this.compareOne.filters.getAllFilters(this.getAllFiltersLoad.bind(this), "compareOne");
            this.compareTwo.filters.getAllFilters(this.getAllFiltersLoad.bind(this), "compareTwo");
        }

        getAllFiltersLoad(compareGroup) {
            this[compareGroup].filtersLoaded = true;
            if (this.compareOne.filtersLoaded && this.compareTwo.filtersLoaded) {
                this.exploreLists.getExploreLists();
            }
        }

        loadingComplete() {
            document.getElementById("loadingSpinnerHolder").classList.remove("active");
            document.getElementById("main").classList.remove("mainHidden");
            updatePageTitle();
            return this;
        }

        setExploreListTitleForCompare(comparisonGroup, name) {
            document.querySelector(`.compareGroupTitle[data-compare_element='${comparisonGroup}']`).value = name;
            this[comparisonGroup].title = name;
            this[comparisonGroup].analysis.newComparisonGroupTitle(name);
            return this;
        }

        compareGroupTitleChange(element) {
            let comparisonGroup = element.dataset.compare_element;
            element.blur();
            this[comparisonGroup].title = element.value;
            this[comparisonGroup].analysis.newComparisonGroupTitle(element.value);
            return this;
        }

        removeCompareGroupTitleAnimation(element) {
            element.classList.remove("borderFlash");
        }

        updateGroupTitleElements(compareGroup) {
            let compareGroupTitleElements = document.querySelectorAll(`.compareGroupTitleElement[data-compare-element='${compareGroup}']`);
            Array.from(compareGroupTitleElements).forEach(element => element.innerHTML = this[compareGroup].title);
            return this;
        }

        startComparisonAnalysis() {
            const self = this;
            this.compareOne.analysis.filtersObject = this.compareOne.filters;
            this.compareTwo.analysis.filtersObject = this.compareTwo.filters;
            this.showCompareLoadingOverlay().hideAllFilterControls().resetAnalysisProgressFlag();
            this.compareOne.analysis.getAnalysis(this.compareOne.filters.getFiltersForSearch(), this.compareAnalysisLoaded.bind(self), "compareOne");
            this.compareTwo.analysis.getAnalysis(this.compareTwo.filters.getFiltersForSearch(), this.compareAnalysisLoaded.bind(self), "compareTwo");
            return this;
        }

        compareAnalysisLoaded(compareGroup, filtersForSearch) {
            this[compareGroup].analysisLoaded = true;
            this[compareGroup].filters.saveFiltersState(filtersForSearch).updateExploreLink();
            if (this.compareOne.analysisLoaded && this.compareTwo.analysisLoaded) {
                this.resetComparisonAnalysis().processComparisonAnalysisResults().resetAnalysisContent().createWidgetSubsections().addComparisonSummary().displaySectionNavigation().createAnalysisWidgets().saveComparisonState().hideCompareLoadingOverlay();
            }
        }

        resetAnalysisProgressFlag() {
            this.compareOne.analysisLoaded = false;
            this.compareTwo.analysisLoaded = false;
        }

        hideAllFilterControls() {
            this.compareOne.filters.hideFilterControls();
            this.compareTwo.filters.hideFilterControls();
            return this;
        }

        addComparisonSummary() {
            let listSummaryPanel, listSummaryWrapper, contentHolder, gvaSummaryElement, compareSummaryHolder, compareOneSummary, compareTwoSummary;

            listSummaryPanel = coreFunctions.createElementHelper("div", { class: "listSummaryPanel"});
            document.querySelector(`#listSummaryHolder .subsection[data-section='Summary'] .mainDataHolder`).appendChild(listSummaryPanel);

            listSummaryWrapper = coreFunctions.createElementHelper("div", { class: "listSummaryWrapper"});
            listSummaryPanel.appendChild(listSummaryWrapper);

            contentHolder = coreFunctions.createElementHelper("div", { class: "barchartHolder"});
            listSummaryWrapper.appendChild(contentHolder);

            contentHolder.appendChild(coreFunctions.createElementHelper("h3")).appendChild(coreFunctions.createElementHelper("span", {class: "widgetTitle", innerHTML: "Comparison summary"}));

            compareSummaryHolder = contentHolder.appendChild(coreFunctions.createElementHelper("div", {class: "compareSummaryHolder"}));

            compareOneSummary = compareSummaryHolder.appendChild(coreFunctions.createElementHelper("div", {class: "compareSummary", "data-compare_element": "compareOne"}));
            this.compareOne.analysis.addResultsToAnalysisSummary(compareOneSummary);

            compareTwoSummary = compareSummaryHolder.appendChild(coreFunctions.createElementHelper("div", {class: "compareSummary", "data-compare_element": "compareTwo"}));
            this.compareTwo.analysis.addResultsToAnalysisSummary(compareTwoSummary);

            // contentHolder.appendChild(this.createComparisonSummaryDataElement("companiesConsidered", "Companies considered", "numerical"));
            // contentHolder.appendChild(this.createComparisonSummaryDataElement("bestEstimateTotalEmployees", "Total employees", "numerical"));
            // contentHolder.appendChild(this.createComparisonSummaryDataElement("bestEstimateTotalTurnover", "Total turnover", "currency"));
            // contentHolder.appendChild(this.createComparisonSummaryDataElement("totalDealroomFunding", "Total investment funding (via Dealroom)", "currency"));
            // contentHolder.appendChild(this.createComparisonSummaryDataElement("totalInnovateUkFunding", "Total Innovate UK grant funding", "currency"));
            // contentHolder.appendChild(this.createComparisonSummaryDataElement("bestEstimateGrowthPercentagePerYear", "Estimated growth per year", "percentage"));
            // gvaSummaryElement = contentHolder.appendChild(this.createComparisonSummaryDataElement("bestEstimateGVA", "Estimated total GVA", "currency"));
            // this.addGvaPerEmployeeToSummary(gvaSummaryElement);
            return this;
        }

        displaySectionNavigation() {
            configureSectionNavigation();
            document.getElementById("sectionHolder").classList.remove("hidden");
            return this;
        }

        hideSectionNavigation() {
            document.getElementById("sectionHolder").classList.add("hidden");
            return this;
        }

        createComparisonSummaryDataElement(field, label, dataType) {
            const formatter = {
                numerical: new Intl.NumberFormat(),
                percentage: new Intl.NumberFormat('en', { style: 'percent', signDisplay: 'exceptZero', minimumSignificantDigits: 2}),
                currency: new Intl.NumberFormat('en-EN', { style: 'currency', maximumFractionDigits: 0, currency: 'GBP' })
            };

            let comparisonSummaryDataElement = coreFunctions.createElementHelper("div", {class: "comparisonSummaryDataHolder"});

            comparisonSummaryDataElement.appendChild(coreFunctions.createElementHelper("div", {class:"comparisonSummaryElement", "data-compare_element": "compareOne", innerHTML: `<div class="comparisonSummaryLabel compareGroupTitleElement" data-compare-element="compareOne">${this.compareOne.title}</div><div class="comparisonSummaryTotal">${(this.compareOne.analysis[field]) ? formatter[dataType].format(this.compareOne.analysis[field]) : "Unknown"}</div><div class="comparisonSummaryLabel">${label}</div>`}));

            comparisonSummaryDataElement.appendChild(coreFunctions.createElementHelper("div", {class:"comparisonSummaryElement", "data-compare_element": "compareTwo", innerHTML: `<div class="comparisonSummaryLabel compareGroupTitleElement" data-compare-element="compareTwo">${this.compareTwo.title}</div><div class="comparisonSummaryTotal">${(this.compareTwo.analysis[field]) ? formatter[dataType].format(this.compareTwo.analysis[field]) : "Unknown"}</div><div class="comparisonSummaryLabel">${label}</div>`}));

            return comparisonSummaryDataElement;

        }

        addGvaPerEmployeeToSummary(holder) {
            const currencyFormat = new Intl.NumberFormat('en-EN', { style: 'currency', maximumFractionDigits: 0, currency: 'GBP' })
            let compareOneHolder = holder.querySelector(".comparisonSummaryElement[data-compare_element='compareOne']");
            let compareTwoHolder = holder.querySelector(".comparisonSummaryElement[data-compare_element='compareTwo']");
            if (this.compareOne.analysis.bestEstimateGVA) {
                compareOneHolder.appendChild(coreFunctions.createElementHelper("div", {class: "summaryTotal secondarySummaryTotal", innerHTML: currencyFormat.format(this.compareOne.analysis.calculateGvaPerEmployeeEstimate())}));
                compareOneHolder.appendChild(coreFunctions.createElementHelper("div", {class: "summaryLabel secondarySummaryLabel", innerHTML: "Estimated GVA per employee"}));
            }
            if (this.compareTwo.analysis.bestEstimateGVA) {
                compareTwoHolder.appendChild(coreFunctions.createElementHelper("div", {class: "summaryTotal secondarySummaryTotal", innerHTML: currencyFormat.format(this.compareTwo.analysis.calculateGvaPerEmployeeEstimate())}));
                compareTwoHolder.appendChild(coreFunctions.createElementHelper("div", {class: "summaryLabel secondarySummaryLabel", innerHTML: "Estimated GVA per employee"}));
            }
            return this;
        }

        showCompareLoadingOverlay() {
            document.getElementById("listInsightsPageLoadingHolder").classList.add("active");
            return this;
        }

        hideCompareLoadingOverlay() {
            document.getElementById("listInsightsPageLoadingHolder").classList.remove("active");
            return this;
        }

        resetComparisonAnalysis() {
            this.comparisonResults.fields = [];
            return this;
        }

        // Get all fields in both sets of analysis and remove duplicates
        getAllFieldsInComparison() {
            return [...new Set(this.compareOne.analysis.fields.concat(this.compareTwo.analysis.fields).map(fieldAnalysis => fieldAnalysis.field))];
        }

        processComparisonAnalysisResults() {
            const comparisonObject = this;
            let allFields, analysisResultsCombined;
            allFields = this.getAllFieldsInComparison();
            analysisResultsCombined = this.compareOne.analysis.fields.concat(this.compareTwo.analysis.fields);
            allFields.forEach(field => comparisonObject.processComparisonResultsForField(field, analysisResultsCombined));
            return this;
        }

        // Combine both comparisons into consituent field elements
        createCombinedFieldResultsElementsArray(allFieldResultsElements, field) {
            const comparisonObject = this;
            let combinedFieldResultsElementsObject = {};
            let yearlyDataFields = ["CompanyFoundingDates", "DealroomFundingByYear", "InnovateUKFundingByYear"];
            allFieldResultsElements.forEach(element => {
                let thing = element.thing;
                if (thing) {
                    // Define entry for particular thing
                    if (!combinedFieldResultsElementsObject[thing]) {
                        combinedFieldResultsElementsObject[thing] = {
                            combinedCount: 0,
                            combinedQuotientCount: 0,
                            thing: thing,
                            description: comparisonObject.addSicDescription(thing, field),
                            compareOne: null,
                            compareTwo: null
                        }
                    }
                    combinedFieldResultsElementsObject[thing].combinedCount += element.count;
                    combinedFieldResultsElementsObject[thing].combinedQuotientCount += (element.quotient ?? 0);
                    combinedFieldResultsElementsObject[thing][element.comparisonGroup] = element;
                }
            });

            // Certain fields are sorted by keys
            if (yearlyDataFields.includes(field)) {
                return Object.values(combinedFieldResultsElementsObject).sort((a, b) => (a.thing < b.thing) ? 1 : -1);
            } else {
                return Object.values(combinedFieldResultsElementsObject).sort((a, b) => (a.combinedCount < b.combinedCount) ? 1 : -1);
            }
        }

        // Check for field SIC description
        addSicDescription(thing, field) {
            let sicDescriptionSearch;
            if (field.startsWith("SIC")) {
                sicDescriptionSearch = sicCodes.find(entry => entry.code == thing);
                if (sicDescriptionSearch) {
                    return sicDescriptionSearch.description;
                } else {
                    return null;
                }
            } else {
                return null;
            }

        }

        createCombinedFinancialFieldResultsElementsArray(allFieldResultsElements) {
            let combinedFieldResultsElementsObject = {};
            allFieldResultsElements.forEach(element => {
                let year = element.year.toString();
                if (!combinedFieldResultsElementsObject[year]) {
                    combinedFieldResultsElementsObject[year] = {
                        year: element.year,
                        compareOne: null,
                        compareTwo: null
                    }
                }
                combinedFieldResultsElementsObject[year][element.comparisonGroup] = element;
            });
            return Object.values(combinedFieldResultsElementsObject).sort((a, b) => (a.year < b.year) ? -1 : 1);
        }

        isFinancialField(testElement) {
            return (testElement.constructor && (testElement.constructor.name == "CompareAnalysisFinancialFieldElement"));
        }

        processComparisonResultsForField(field, analysisResultsCombined) {
            let allFieldResults, allFieldResultsElements, combinedFieldResultsElementsArray, allFieldResultsLocationQuotientElements, combinedFieldLocationQuotientElementsArray;
            // Filter all anlysis for this field
            allFieldResults = analysisResultsCombined.filter(analysisFields => analysisFields.field == field);

            // There is a comparison to be done, data for each compare group
            if (allFieldResults.length > 1) {

                // Should be compare one and compare two groups, get individual filter elements
                allFieldResultsElements = allFieldResults.map(fieldAnalysis => fieldAnalysis.fieldElements).flat();

                // Results are available per element
                if (allFieldResultsElements.length > 0) {
                    if (this.isFinancialField(allFieldResultsElements[0])) {
                        combinedFieldResultsElementsArray = this.createCombinedFinancialFieldResultsElementsArray(allFieldResultsElements);
                    } else {
                        combinedFieldResultsElementsArray = this.createCombinedFieldResultsElementsArray(allFieldResultsElements, field);
                    }

                    combinedFieldLocationQuotientElementsArray = (combinedFieldResultsElementsArray.find(element => element.combinedQuotientCount)) ? this.processLocationQuotientArray([...combinedFieldResultsElementsArray]) : [];
                }

                this.newComparisonResultsField(allFieldResults[0].field, allFieldResults[0].label, allFieldResults[0].subsection, allFieldResults[0].dataType, allFieldResults[0].explanation, allFieldResults[0].chartType, allFieldResults[0].allowedChartTypes, allFieldResults[0].thingColumnLabel, allFieldResults[0].emptyFieldLabel, allFieldResults[0].topCompanies, allFieldResults[1].topCompanies, combinedFieldResultsElementsArray, combinedFieldLocationQuotientElementsArray, allFieldResults[0].displayDataAsPercentage, allFieldResults[0].totalCount, allFieldResults[1].totalCount);
            }
            return this;
        }

        processLocationQuotientArray(array) {
            return array.sort((a,b) => b.combinedQuotientCount - a.combinedQuotientCount);
        }

        newComparisonResultsField(field, label, subsection, dataType, explanation, chartType, allowedChartTypes, thingColumnLabel, emptyFieldLabel, compareOneTopCompanies, compareTwoTopCompanies, results, locationQuotientResults, displayDataAsPercentage, compareOneTotalCount, compareTwoTotalCount) {
            let comparisonResultsField = new ComparisonResultsField(field, label, subsection, dataType, explanation, chartType, allowedChartTypes, thingColumnLabel, emptyFieldLabel, compareOneTopCompanies, compareTwoTopCompanies, results, locationQuotientResults, displayDataAsPercentage, compareOneTotalCount, compareTwoTotalCount, this.compareOne.title, this.compareTwo.title);
            this.comparisonResults.fields.push(comparisonResultsField);
            return comparisonResultsField;
        }

        createWidgetSubsections() {
            let listSummaryHolder = document.getElementById("listSummaryHolder");
            const subsections = ["Summary"].concat(this.comparisonResults.fields.map(element => element.subsection).filter((item, i, ar) => ar.indexOf(item) === i));
            subsections.forEach((subsection) => {
                let subsectionHolder = coreFunctions.createElementHelper("div", { class: "subsection", "data-section": subsection });
                listSummaryHolder.appendChild(subsectionHolder);
                if (subsection != "Summary") {
                    subsectionHolder.appendChild(coreFunctions.createElementHelper("h2", { innerHTML: subsection })); // Title of subsection
                }
                subsectionHolder.appendChild(coreFunctions.createElementHelper("div", { class: "mainDataHolder" })); // Holder for widgets
                document.getElementById("sectionsList").appendChild(coreFunctions.createElementHelper("button", {innerHTML: subsection, class: "sectionElement", "data-section": subsection}, {click: function() {
                    document.querySelector(`.subsection[data-section='${this.dataset.section}']`).scrollIntoView({behavior: "smooth", block: "start"});
                }})); // Add subsection to selection control
            })
            return this;
        }

        resetAnalysisContent() {
            let listSummaryHolder, sectionsList;
            listSummaryHolder = document.getElementById("listSummaryHolder");
            coreFunctions.clearElementChildren(listSummaryHolder);
            sectionsList = document.getElementById("sectionsList");
            while (sectionsList.firstChild) {
                sectionsList.removeChild(sectionsList.firstChild);
            }
            return this;
        }

        createAnalysisWidgets() {
            this.comparisonResults.fields.forEach(field => field.createAnalysisWidget());
            return this;
        }

        editWidgetSubmit(form) {
            let field = form.querySelector("input[name='field']").value;
            let newChartType = form.querySelector("input[name='chartType']:checked").value;
            this.comparisonResults.fields.find(analysisField => analysisField.field == field).checkForChartRefresh(newChartType);
            coreFunctions.hideOverlay(document.querySelector("#editWidgetOverlay .overlayClose"));
        }


        saveComparisonState() {
            // Code here to save settings (titles, filters) if needed
            return this;
        }

        prepareCompleteComparisonDownload() {
            let method, url;
            const compareObject = this;
            const input = {
                title: "TDC_Compare",
                analysis: this.processCompleteComparisonDownloadData()
            }

            method = "POST";
            url = `../api/analyse/analyse_actions.php?action=prepare_compare_download`;

            const prepareCompareDownloadSuccess = function (response) {
                const responseParsed = JSON.parse(response);
                let filename = responseParsed.zip_filename;
                compareObject.downloadCompleteComparison(filename);
            }

            const prepareCompareDownloadError = function () {
                console.log("Error preparing download");
            }

            coreFunctions.xhrHelper(method, url, prepareCompareDownloadSuccess, prepareCompareDownloadError, JSON.stringify(input));

        }

        processCompleteComparisonDownloadData() {
            const completeComparisonDownloadData = [];
            this.comparisonResults.fields.forEach((field) => {
                completeComparisonDownloadData.push(field.processFieldForCompleteComparisonDownload());
            });
            return completeComparisonDownloadData;
        }

        downloadCompleteComparison(filename) {
            let a = window.document.createElement("a");
            a.download = "";
            a.href = `../api/analyse/analyse_actions.php?action=download&filename=${filename}`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    }

    class ComparisonResultsField {
        constructor(field, label, subsection, dataType, explanation, chartType, allowedChartTypes, thingColumnLabel, emptyFieldLabel, compareOneTopCompanies, compareTwoTopCompanies, fieldElements, locationQuotientFieldElements, displayDataAsPercentage, compareOneTotalCount, compareTwoTotalCount, compareOneTitle,  compareTwoTitle) {
            this.field = field;
            this.label = label;
            this.subsection = subsection;
            this.dataType = dataType;
            this.explanation = explanation;
            this.fieldElements = fieldElements;
            this.perCapitaElements = [];
            this.perCapitaMultiplier = 1000;
            this.compareOneTopCompanies = compareOneTopCompanies;
            this.compareTwoTopCompanies = compareTwoTopCompanies;
            this.widget = null;
            this.chartType = chartType;
            this.allowedChartTypes = allowedChartTypes;
            this.thingColumnLabel = thingColumnLabel;
            this.emptyFieldLabel = emptyFieldLabel;
            this.map = null;
            this.locationQuotientElements = locationQuotientFieldElements ?? [];
            this.displayDataAsPercentage = displayDataAsPercentage;
            this.compareOneTotalCount = compareOneTotalCount;
            this.compareTwoTotalCount = compareTwoTotalCount;
            this.compareOneTitle = compareOneTitle;
            this.compareTwoTitle = compareTwoTitle;
        }

        hasLocationData() {
            return (this.fieldElements && this.fieldElements.length > 0 && ((this.fieldElements[0].compareOne != undefined && this.fieldElements[0].compareOne.latitude != undefined && this.fieldElements[0].compareOne.longitude != undefined) || (this.fieldElements[0].compareTwo != undefined && this.fieldElements[0].compareTwo.latitude != undefined && this.fieldElements[0].compareTwo.longitude != undefined)));
        }

        createAnalysisWidget() {
            // There are compare results elements to display
            if (this.fieldElements && this.fieldElements.length) {
                if (this.hasLocationData()) {
                    this.createLocationWidget().createLocationQuotientControl().createDataChart().createMap();
                } else {
                    this.createGeneralWidget().createLocationQuotientControl().createAbsolutePercentageDataToggleControl().createDataChart();
                    this.compareOneTopCompanies.addTopCompaniesToPage();
                    this.compareTwoTopCompanies.addTopCompaniesToPage();
                }
            }
            return this;
        }

        createMap() {
            if (this.hasLocationData()) {
                this.map = new BubbleMap(this.field, null, false).createMap().createMapBubbles(this.fieldElements).getMaxCount().addBubblesToMap();
            }
            return this;
        }

        createLocationQuotientMap() {
            if (this.hasLocationData()) {
                this.map = new BubbleMap(this.field, null, true).createMap().createMapBubbles(this.locationQuotientElements).getMaxCount().addBubblesToMap();
            }
            return this;
        }

        createDataChart() {
            if (this.chartType == "line") {
                if (this.isFinancialField()) {
                    new CompareLinechart(this.field, this.fieldElements, this.label, this.dataType, this.compareOneTitle, this.compareTwoTitle).prepareLinechartHolder().drawLinechart();
                } else if (this.field == "CompanyFoundingDates") {
                    new CompareLinechart(this.field, this.fieldElements, this.label, this.dataType, this.compareOneTitle, this.compareTwoTitle).prepareLinechartHolder().drawCumulativeLinechart().addCumulativeLinechartSummary();
                } else if (this.field == "CompanyJobPostingsOverTimeBySOC4") {
                    new CompareLinechart(this.field, this.fieldElements, this.label, this.dataType, this.compareOneTitle, this.compareTwoTitle).prepareLinechartHolder().drawTimestampLineChart()
                }
            } else {
                if (this.isFinancialField()) {
                    new FinancialsBarchart(this.field, this.fieldElements, this.label).getMaximumCount().createBarchart();
                } else {
                    let barchart = new Barchart(this.field, this.fieldElements, this.dataType, this.emptyFieldLabel, this.label, false, this.compareOneTotalCount, this.compareTwoTotalCount).getMaximumCount().createBarchart();
                }
            }
            return this;
        }

        isFinancialField() {
            return (this.fieldElements && this.fieldElements.length > 0 && ((this.fieldElements[0].compareOne && this.fieldElements[0].compareOne.constructor.name == "CompareAnalysisFinancialFieldElement") || (this.fieldElements[0].compareTwo && this.fieldElements[0].compareTwo.constructor.name == "CompareAnalysisFinancialFieldElement")));
        }

        checkForChartRefresh(newChartType) {
            if (this.chartType != newChartType) {
                this.resetDataChart(newChartType).createDataChart();
            }
        }

        resetDataChart(newChartType) {
            let existingChartContent = document.querySelector(`.barchartHolder[field='${this.field}'] .barchartContentWrapper`);
            existingChartContent.parentNode.removeChild(existingChartContent);
            this.chartType = newChartType;
            return this;
        }

        createLocationWidget() {
            let subsection, locationWidgetHolder, locationWidgetWrapper, locationData;
            subsection = document.querySelector(`#listSummaryHolder .subsection[data-section='${this.subsection}']`);

            locationWidgetHolder = coreFunctions.createElementHelper("div", { class: "locationDataHolder", id: `${this.field}Widget` });
            subsection.insertBefore(locationWidgetHolder, subsection.lastChild);

            locationWidgetWrapper = coreFunctions.createElementHelper("div", { class: "locationDataWrapper" });
            locationWidgetHolder.appendChild(locationWidgetWrapper);
            locationWidgetWrapper.appendChild(this.createWidgetTitleBar());

            locationData = coreFunctions.createElementHelper("div", { class: "locationData" });
            locationWidgetWrapper.appendChild(locationData);
            locationData.appendChild(this.createLocationWidgetVisualisationHolder(false));
            locationData.appendChild(this.createLocationWidgetVisualisationHolder(true))

            return this;
        }

        hasLocationQuotientData() {
            return this.locationQuotientElements.length > 0;
        }

        createLocationQuotientControl() {
            let controls;
            const analysisFieldObject = this;

            if (this.hasLocationQuotientData()) {
                controls = coreFunctions.createElementHelper("form", { field: this.field, class: "chartSourceDataControls" }, { change: function () { analysisFieldObject.locationQuotientControlChange() } });

                controls.appendChild(coreFunctions.createElementHelper("input", { type: "radio", id: `${this.field}-absolute`, name: `${this.field}-chartSourceData`, value: "absolute", checked: true }));

                controls.appendChild(coreFunctions.createElementHelper("label", { for: `${this.field}-absolute`, innerHTML: "Absolute" }));

                controls.appendChild(coreFunctions.createElementHelper("input", { type: "radio", id: `${this.field}-locationquotient`, name: `${this.field}-chartSourceData`, value: "locationquotient" }));

                controls.appendChild(coreFunctions.createElementHelper("label", { for: `${this.field}-locationquotient`, innerHTML: `Location quotient` }));

                document.querySelector(`.barchartHolder[field='${this.field}']`).appendChild(controls);
            }
            return this;
        }

        locationQuotientControlChange() {
            let dataSource = document.querySelector(`[name='${this.field}-chartSourceData']:checked`).value;
            if (dataSource == "absolute") {
                new Barchart(this.field, this.fieldElements, this.dataType, this.emptyFieldLabel, this.label, false, null, null, false).getMaximumCount().createBarchart();
                this.createMap();
            } else {
                new Barchart(this.field, this.locationQuotientElements, "numerical", this.emptyFieldLabel, this.label, false, null, null, true).getMaximumCount().createBarchart();
                this.createLocationQuotientMap();

            }
        }

        createGeneralWidget() {
            let listSummaryPanel, listSummaryWrapper, barchartHolder;

            listSummaryPanel = coreFunctions.createElementHelper("div", { class: "listSummaryPanel", field: this.field, id: `${this.field}Widget` });
            document.querySelector(`#listSummaryHolder .subsection[data-section='${this.subsection}'] .mainDataHolder`).appendChild(listSummaryPanel);

            listSummaryWrapper = coreFunctions.createElementHelper("div", { class: "listSummaryWrapper" });
            listSummaryPanel.appendChild(listSummaryWrapper);

            barchartHolder = coreFunctions.createElementHelper("div", { class: `barchartHolder${(this.isFinancialField()) ? " financialsBarchartHolder" : ""}`, field: this.field });
            listSummaryWrapper.appendChild(barchartHolder);

            barchartHolder.appendChild(this.createWidgetTitleBar());

            return this;
        }

        createLocationWidgetVisualisationHolder(mapVisualisation) {
            let listSummaryPanel;
            listSummaryPanel = coreFunctions.createElementHelper("div", { class: "listSummaryPanel" });
            listSummaryPanel.appendChild(coreFunctions.createElementHelper("div", { class: "listSummaryWrapper" })).appendChild(coreFunctions.createElementHelper("div", { class: `barchartHolder${(mapVisualisation) ? " mapHolder" : ""}`, field: this.field }));
            return listSummaryPanel;
        }

        createWidgetTitleBar() {
            let titleBar, widgetTitle, widgetControls;

            titleBar = coreFunctions.createElementHelper("h3");

            widgetTitle = coreFunctions.createElementHelper("span", { class: "widgetTitle", innerHTML: this.label });
            titleBar.appendChild(widgetTitle);

            widgetControls = coreFunctions.createElementHelper("span", { class: "widgetControls" });
            titleBar.appendChild(widgetControls);

            // Explanation for widget
            if (this.explanation) {
                widgetControls.appendChild(this.createWidgetExplanationElement());
            }
            widgetControls.appendChild(this.createWidgetControlsElements());

            return titleBar;
        }

        createWidgetControlsElements() {
            let insightsWidgetActionsControlHolder, insightsWidgetActionControlLabel, insightsWidgetActionControlLabelToggle, actionsHolder;
            const analyisFieldObject = this;
            insightsWidgetActionsControlHolder = coreFunctions.createElementHelper("span", { class: "insightsActionsControlHolder" });
            insightsWidgetActionsControlHolder.appendChild(coreFunctions.createElementHelper("input", { class: "insightsActionsControl", type: "checkbox", id: `insightsActionsControl-${this.field}`, field: this.field })); // Checkbox element

            insightsWidgetActionControlLabel = coreFunctions.createElementHelper("label", { class: "insightsActionsControlLabel", for: `insightsActionsControl-${this.field}` });
            insightsWidgetActionsControlHolder.appendChild(insightsWidgetActionControlLabel); // Label element for content

            insightsWidgetActionControlLabelToggle = coreFunctions.createElementHelper("span", { "class": "controlsToggle", innerHTML: "&nbsp;" });
            insightsWidgetActionControlLabel.appendChild(insightsWidgetActionControlLabelToggle);

            actionsHolder = coreFunctions.createElementHelper("span", { class: "controls" });
            insightsWidgetActionControlLabelToggle.appendChild(actionsHolder);

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Edit widget</span>", class: "actionControl actions-edit", field: this.field, title: "Edit widget" }, { click: function (e) { analyisFieldObject.prepareEditWidgetControls() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Download</span>", class: "actionControl actions-download", field: this.field, title: "Download analysis data" }, { click: function (e) { analyisFieldObject.downloadAnalysisData() } })); // Download analysis data

            actionsHolder.appendChild(coreFunctions.createElementHelper("a", { innerHTML: `<span>View <span class='compareGroupTitleElement' data-compare-element='compareOne'>${comparison.compareOne.title}</span> list</span>`, class: "actionControl actions-view-list", "data-compare-element": 'compareOne', target: "_blank", href: `${urlPath}${`/explore?filters_code=${comparison.compareOne.filters.storedFiltersCode}`}` }, { click: function () { comparison.compareOne.filters.copyComparisonGroupFiltersToStoredFilters(); } })); // View compare one list action

            actionsHolder.appendChild(coreFunctions.createElementHelper("a", { innerHTML: `<span >View <span class='compareGroupTitleElement' data-compare-element='compareTwo'>${comparison.compareTwo.title}</span> list</span>`, class: "actionControl actions-view-list", "data-compare-element": 'compareTwo', target: "_blank", href: `${urlPath}${`/explore?filters_code=${comparison.compareTwo.filters.storedFiltersCode}`}` }, { click: function () { comparison.compareTwo.filters.copyComparisonGroupFiltersToStoredFilters() } })); // View compare two list action

            return insightsWidgetActionsControlHolder;
        }

        prepareEditWidgetControls() {
            const analysisField = this;
            let chartTypeControls = Array.from(document.querySelectorAll("#editWidgetForm input[name='chartType']"));
            // Hide widget actions
            document.querySelector(`.insightsActionsControl[field='${analysisField.field}']`).checked = false;

            // Set field value
            document.querySelector("#editWidgetForm input[name='field']").value = analysisField.field;
            // Set current type of chart
            document.querySelector(`#editWidgetForm input[name='chartType'][value='${analysisField.chartType}']`).checked = true;
            // Setup controls according to charts allowed for a particular field
            chartTypeControls.forEach(function (control) {
                if (analysisField.allowedChartTypes.indexOf(control.value) == -1) {
                    control.disabled = true;
                } else {
                    control.disabled = false;
                }
            });
            coreFunctions.showOverlay("editwidget");

            document.getElementById("editWidgetForm")
        }

        createWidgetExplanationElement() {
            let widgetExplanationHolder = coreFunctions.createElementHelper("span", { class: "widgetExplanationHolder" });

            widgetExplanationHolder.appendChild(coreFunctions.createElementHelper("input", { type: "checkbox", id: `widgetExplanationCheckbox${this.field}` })); // Checkbox

            widgetExplanationHolder.appendChild(coreFunctions.createElementHelper("label", { for: `widgetExplanationCheckbox${this.field}`, innerHTML: `?<span class='widgetExplanation'>${this.explanation}</span>` })); // Label with explanation element can be toggled on and off

            return widgetExplanationHolder;
        }

        downloadAnalysisData() {
            let csvData, csv, blob, a, fileTitle;
            // Hide widget actions
            document.querySelector(`.insightsActionsControl[field='${this.field}']`).checked = false;
            csvData = this.processCsvData();
            csv = Papa.unparse(csvData);
            blob = new Blob([csv]);
            // Srip out HTML tags from title
            fileTitle = `TDC_Compare-${this.label.replace(/(<([^>]+)>)/gi, "").replace(/ /g, "_")}.csv`;

            // For IE
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob, fileTitle);
            }
            // Other browsers
            else {
                a = window.document.createElement("a");
                a.href = window.URL.createObjectURL(blob, {
                    type: "text/plain"
                });
                a.download = fileTitle;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        }

        // Process header row for CSV download
        getHeaders(fieldIsSic, hasLocationQuotientData, isFinancialField) {
            let description = (this.dataType == "percentage") ? "percentage" : "count";
            const headers = [this.thingColumnLabel ?? "Year"];

            if (isFinancialField) {
                headers.push(`${this.compareOneTitle} measured total (GBP)`, `${this.compareOneTitle} measured companies`, `${this.compareOneTitle} projected total (GBP)`, `${this.compareOneTitle} projected companies`, `${this.compareTwoTitle} measured total (GBP)`, `${this.compareTwoTitle} measured companies`, `${this.compareTwoTitle} projected total (GBP)`, `${this.compareTwoTitle} projected companies`);
            } else {
                if (fieldIsSic) {
                    headers.push("SIC Description");
                }

                headers.push(`${this.compareOneTitle} ${description}`);
                if (hasLocationQuotientData === true) {
                    headers.push(`${this.compareOneTitle} location quotient`);
                }
                headers.push(`${this.compareTwoTitle} ${description}`);
                if (hasLocationQuotientData === true) {
                    headers.push(`${this.compareTwoTitle} location quotient`);
                }
            }
            return headers;
        }

        processCsvData() {
            let fieldIsSic, isFinancialField, elementFieldData, compareOneCsvElement, compareTwoCsvElement, totalElements, header, fieldElement, hasLocationQuotientData;
            const csvData = [];
            totalElements = this.fieldElements.length;
            fieldIsSic = this.fieldIsSic();
            isFinancialField = this.isFinancialField();
            hasLocationQuotientData = this.hasLocationQuotientData();
            header = true;
            for (var i = 0; i < totalElements; i++) {
                fieldElement = this.fieldElements[i];
                elementFieldData = this.formatElementFieldData(fieldElement, isFinancialField, fieldIsSic);
                if (fieldElement.compareOne) {
                    if (header) {
                        csvData.push(this.getHeaders(fieldIsSic, hasLocationQuotientData, isFinancialField));
                        header = false;
                    }
                    compareOneCsvElement = fieldElement.compareOne.formatElementForCsv();
                    if (hasLocationQuotientData) {
                        compareOneCsvElement.push(this.locationQuotientSearch(fieldElement.compareOne.comparisonGroup, fieldElement.compareOne.thing));
                    }

                } else {
                    compareOneCsvElement = this.noElementAvailableForCsv(isFinancialField, hasLocationQuotientData);
                }

                if (fieldElement.compareTwo) {
                    if (header) {
                        csvData.push(this.getHeaders(fieldIsSic, hasLocationQuotientData, isFinancialField));
                        header = false;
                    }
                    compareTwoCsvElement = fieldElement.compareTwo.formatElementForCsv();
                    if (hasLocationQuotientData) {
                        compareTwoCsvElement.push(this.locationQuotientSearch(fieldElement.compareTwo.comparisonGroup, fieldElement.compareTwo.thing));
                    }
                } else {
                    compareTwoCsvElement = this.noElementAvailableForCsv(isFinancialField, hasLocationQuotientData);
                }

                csvData.push(elementFieldData.concat(compareOneCsvElement, compareTwoCsvElement));
            }
            return csvData;
        }

        locationQuotientSearch(comparisonGroup, location) {
            let locationSearch;
            if (locationSearch = this.locationQuotientElements.map(element => element[comparisonGroup]).filter(element => element != undefined).find(element => element.thing == location)) {
                return locationSearch.count;
            } else {
                return "";
            }
        }

        hasPercentageData() {
            return this.displayDataAsPercentage === true;
        }

        createAbsolutePercentageDataToggleControl() {
            let controls;
            const comparisonResultsFieldObject = this;

            if (this.hasPercentageData()) {
                controls = coreFunctions.createElementHelper("form", { field: this.field, class: "chartSourceDataControls" }, { change: function () { comparisonResultsFieldObject.absolutePercentageDataToggleChange() } });

                controls.appendChild(coreFunctions.createElementHelper("input", { type: "radio", id: `${this.field}-absoluteData`, name: `${this.field}-absolutePercentageData`, value: "absolute", checked: true }));

                controls.appendChild(coreFunctions.createElementHelper("label", { for: `${this.field}-absoluteData`, innerHTML: "Absolute" }));

                controls.appendChild(coreFunctions.createElementHelper("input", { type: "radio", id: `${this.field}-percentageData`, name: `${this.field}-absolutePercentageData`, value: "percentage" }));

                controls.appendChild(coreFunctions.createElementHelper("label", { for: `${this.field}-percentageData`, innerHTML: "Percentage" }));

                document.querySelector(`.barchartHolder[field='${this.field}']`).appendChild(controls);
            }

            return this;
        }

        absolutePercentageDataToggleChange() {
            let dataSource = document.querySelector(`[name='${this.field}-absolutePercentageData']:checked`).value;
            if (dataSource == "percentage") {
                new Barchart(this.field, this.fieldElements, this.dataType, this.emptyFieldLabel, this.label, false, this.compareOneTotalCount, this.compareTwoTotalCount).getMaximumCount(true).createBarchart(true)
            } else {
                new Barchart(this.field, this.fieldElements, this.dataType, this.emptyFieldLabel, this.label, false, this.compareOneTotalCount, this.compareTwoTotalCount).getMaximumCount().createBarchart()
            }
        }

        fieldIsSic() {
            return this.field.startsWith("SIC");
        }

        formatElementFieldData(fieldElement, isFinancialField, fieldIsSic) {
            let sicSearch;
            if (isFinancialField) {
                return [fieldElement.year];
            } else if (fieldIsSic) {
                sicSearch = sicCodes.find(sic => sic.code == fieldElement.thing);
                if (sicSearch) {
                    return [fieldElement.thing, sicSearch.description];
                } else {
                    return [fieldElement.thing, null];
                }
            } else {
                return [fieldElement.thing];
            }
        }

        noElementAvailableForCsv(isFinancialField, hasLocationQuotientData) {
            if (isFinancialField) {
                return [null, null, null, null];
            } else if (hasLocationQuotientData) {
                return [null, null];
            } else {
                return [null]
            }
        }

        processFieldForCompleteComparisonDownload() {
            const processedFieldForDownload = {
                name: this.label,
                data: []
            };
            let fieldIsSic, isFinancialField, elementFieldObject, totalElements, fieldElement, compareOneProcessedElement, compareTwoProcessedElement, hasLocationQuotientData;
            totalElements = this.fieldElements.length;
            fieldIsSic = this.fieldIsSic();
            isFinancialField = this.isFinancialField();
            hasLocationQuotientData = this.hasLocationQuotientData();
            for (var i = 0; i < totalElements; i++) {
                elementFieldObject = {};
                fieldElement = this.fieldElements[i];
                Object.assign(elementFieldObject, this.formatElementFieldDataForCompleteDownload(fieldElement, isFinancialField, fieldIsSic));
                if (fieldElement.compareOne) {
                    compareOneProcessedElement = fieldElement.compareOne.processElementForCompleteDownload();

                    Object.assign(elementFieldObject, compareOneProcessedElement);
                    if (hasLocationQuotientData === true) {
                       elementFieldObject[`${comparison.compareOne.title} Location Quotient`] = this.locationQuotientSearch("compareOne", fieldElement.compareOne.thing);
                    }
                } else {
                    Object.assign(elementFieldObject, this.noElementAvailableForCompleteDownload(isFinancialField,hasLocationQuotientData, comparison.compareOne.title));
                }
                if (fieldElement.compareTwo) {
                    compareTwoProcessedElement = fieldElement.compareTwo.processElementForCompleteDownload();
                    Object.assign(elementFieldObject, compareTwoProcessedElement);


                    if (hasLocationQuotientData === true) {
                       elementFieldObject[`${comparison.compareTwo.title} Location Quotient`] = this.locationQuotientSearch("compareTwo", fieldElement.compareTwo.thing);
                    }
                } else {
                    Object.assign(elementFieldObject, this.noElementAvailableForCompleteDownload(isFinancialField, hasLocationQuotientData, comparison.compareTwo.title));
                }
                processedFieldForDownload.data.push(elementFieldObject);
            }

            return processedFieldForDownload;
        }

        formatElementFieldDataForCompleteDownload(fieldElement, isFinancialField, fieldIsSic) {
            let sicSearch;
            const elementFieldData = {};
            if (isFinancialField) {
                elementFieldData["Year"] = fieldElement.year;
            } else if (fieldIsSic) {
                sicSearch = sicCodes.find(sic => sic.code == fieldElement.thing);
                if (sicSearch) {
                    elementFieldData[this.label] = fieldElement.thing;
                    elementFieldData["SIC description"] = sicSearch.description;
                } else {
                    elementFieldData[this.label] = fieldElement.thing;
                    elementFieldData["SIC description"] = null;
                }
            } else {
                elementFieldData[this.label] = fieldElement.thing;
            }

            return elementFieldData;
        }

        noElementAvailableForCompleteDownload(isFinancialField, hasLocationQuotientData, compareGroupTitle) {
            let elementForCompleteDownload = {};
            if (isFinancialField) {
                elementForCompleteDownload[`${compareGroupTitle} measured total (GBP)`] = null;
                elementForCompleteDownload[`${compareGroupTitle} measured companies`] = null;
                elementForCompleteDownload[`${compareGroupTitle} projected total (GBP)`] = null;
                elementForCompleteDownload[`${compareGroupTitle} projected companies`] = null;
            } else {
                if (this.dataType == "percentage") {
                    elementForCompleteDownload[`${compareGroupTitle} percentage`] = null;
                } else {
                    elementForCompleteDownload[`${compareGroupTitle} count`] = null;
                }
                if (hasLocationQuotientData === true) {
                    elementForCompleteDownload[`${compareGroupTitle} location quotient`] = null;
                }
            }
            return elementForCompleteDownload;
        }

    }

    class BubbleMap {
        constructor(field, perCapitaMultiplier, plotLocationQuotient) {
            this.field = field;
            this.mapElements = [];
            this.map = null;
            this.maxRadius = 25;
            this.maxTotal = null;
            this.perCapitaMultiplier = perCapitaMultiplier;
            this.plotLocationQuotient = plotLocationQuotient ?? false;
        }

        createMap() {
            let existingMapContainer, mapContainer, resultsControl;
            const mapObject = this;

            if (existingMapContainer = document.querySelector(`.mapHolder[field='${this.field}'] .mapContainer`)) {
                document.querySelector(`.mapHolder[field='${this.field}']`).removeChild(existingMapContainer);
            }

            mapContainer = coreFunctions.createElementHelper("div", { class: "mapContainer", id: `${this.field}MapContainer`, field: this.field });
            document.querySelector(`.mapHolder[field='${this.field}']`).appendChild(mapContainer);

            this.map = L.map(`${this.field}MapContainer`, {
                zoomControl: false
            }).setView([51.505, -0.09], 13);

            L.control.zoom({
                position: 'bottomright'
            }).addTo(this.map);

            L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
                subdomains: 'abcd',
                maxZoom: 19,
                className: "LeafletTile"
            }).addTo(this.map);


            // Custom control button
            resultsControl = L.Control.extend({
                options: {
                    position: 'topleft'
                },
                onAdd: function () {
                    let container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
                    container.innerHTML = `<label>Show:</label><select field='${mapObject.field}'><option value='20'>20</option><option value='40'>40</option><option value='60'>60</option><option value='all'>All</option></select>`;
                    L.DomEvent.on(container.querySelector("select"), 'change', function (ev) {
                        mapObject.mapShowChange((this.value == "all") ? "all" : Number(this.value));
                    });
                    return container;
                }
            });
            this.map.addControl(new resultsControl());

            return this;
        }

        getMaxCount() {
            this.maxTotal = Math.max(...this.mapElements.map(element => element.count));
            return this;
        }

        mapShowChange(resultsToShow) {
            let hideMarker = false;
            this.mapElements.forEach((mapElement) => {
                if (hideMarker == false && resultsToShow != "all" && mapElement.siteIndex >= resultsToShow) {
                    hideMarker = true;
                }
                mapElement.refreshMarker(hideMarker);
            });
        }

        createMapBubbles(elements) {
            const mapObject = this;
            let countMultiplier = this.getBubbleCountMultiplier();
            const valueField = (this.plotLocationQuotient === true) ? "quotient" : "count";
            elements.forEach((element, siteIndex) => {
                let compareOneMapBubble, compareTwoMapBubble, foregroundBubbleComparisonGroup;
                foregroundBubbleComparisonGroup = mapObject.calculateForegroundBubbleComparisonGroup(element);
                if (element.compareOne) {
                    compareOneMapBubble = new MapBubble(element.compareOne.comparisonGroup, element.compareOne.thing, (element.compareOne[valueField]  * countMultiplier), element.compareOne.latitude, element.compareOne.longitude, siteIndex, ((foregroundBubbleComparisonGroup == element.compareOne.comparisonGroup) ? "foreground" : "background"));
                    this.mapElements.push(compareOneMapBubble);

                }
                if (element.compareTwo) {
                    compareTwoMapBubble = new MapBubble(element.compareTwo.comparisonGroup, element.compareTwo.thing, (element.compareTwo[valueField] * countMultiplier), element.compareTwo.latitude, element.compareTwo.longitude, siteIndex, ((foregroundBubbleComparisonGroup == element.compareTwo.comparisonGroup) ? "foreground" : "background"));
                    this.mapElements.push(compareTwoMapBubble);
                }
            });
            return this;
        }

        // Check which bubble should be at the foreground of the location, should be the one with the smallest count.
        calculateForegroundBubbleComparisonGroup(element) {
            if (!element.compareOne) {
                return "compareTwo";
            } else if (!element.compareTwo) {
                return "compareOne";
            } else if (element.compareOne.count > element.compareTwo.count) {
                return "compareTwo";
            } else {
                return "compareOne";
            }
        }

        getBubbleCountMultiplier() {
            return (this.perCapitaMultiplier) ? this.perCapitaMultiplier : 1;
        }

        addBubblesToMap() {
            let scaleFactor, mapFeatureGroup;
            const leafletBubblesArray = [];
            scaleFactor = this.maxRadius / Math.sqrt(this.maxTotal);

            this.mapElements.forEach((mapBubble, index) => {
                let leafletBubble = mapBubble.addBubbleToMap(scaleFactor, index);
                if (leafletBubble) {
                    leafletBubblesArray.push(leafletBubble);
                }
            });
            mapFeatureGroup = L.featureGroup(leafletBubblesArray).addTo(this.map);
            this.reorderBubblesVerticalPositions();
            if (leafletBubblesArray.length > 0) {
                this.map.fitBounds(mapFeatureGroup.getBounds());
            } else {
                map.setView(new L.LatLng(55.9819, -4.8999), 5);
            }
            return this;
        }

        reorderBubblesVerticalPositions() {
            this.mapElements.forEach((mapElement) => {
                mapElement.setMarkerVerticalPosition();
            });
            return this;
        }
    }

    class MapBubble {
        constructor(comparisonGroup, thing, count, latitude, longitude, siteIndex,
            zPosition) {
            this.comparisonGroup = comparisonGroup;
            this.thing = thing;
            this.count = count;
            this.latitude = latitude;
            this.longitude = longitude;
            this.maxRadius = 25;
            this.marker = null;
            this.siteIndex = siteIndex;
            this.zPosition = zPosition;
            this.totalBubblesShownByDefault = 20;
        }

        addBubbleToMap(scaleFactor, index) {
            let center;
            if (this.count > 0 && this.latitude && this.longitude) {
                center = [this.latitude, this.longitude];
                this.marker = L.circleMarker(center, {
                    radius: scaleFactor * Math.sqrt(this.count),
                    stroke: false,
                    opacity: 1,
                    fill: true,
                    fillColor: 'transparent',
                    fillOpacity: 1,
                    className: `mapBubble${(this.siteIndex < this.totalBubblesShownByDefault) ? "" : " bubbleHidden"} ${this.comparisonGroup}`,
                    name: this.thing,
                    count: this.count,
                    zPosition: this.zPosition
                }).bindPopup(this.thing);

                // Only add 20 tooltip initially
                if (this.siteIndex < this.totalBubblesShownByDefault) {
                    this.marker.bindTooltip(this.formatTooltipValue(), {
                        permanent: true,
                        direction: ((this.zPosition == "foreground") ? "center" : "top"),
                        className: 'mapBubbleTooltip'
                    });
                }

                return this.marker;
            } else {
                return null;
            }

        }

        setMarkerVerticalPosition() {
            if (this.marker) {
                if (this.zPosition == "foreground") {
                    this.marker.bringToFront();
                } else {
                    this.marker.bringToBack();
                }
            }
        }

        refreshMarker(hideMarker) {
            if (this.marker) {
                if (hideMarker == true) {
                    this.hideMarker();
                } else {
                    this.displayMarker();
                }
            }
        }

        displayMarker() {
            let tooltip = this.marker.getTooltip();
            if (tooltip == undefined) {
                this.marker.bindTooltip(this.formatTooltipValue(), {
                    permanent: true,
                    direction: ((this.zPosition == "foreground") ? "center" : "top"),
                    className: 'mapBubbleTooltip'
                });
            } else {
                tooltip.getElement().classList.remove("bubbleHidden");
            }
            this.marker.getElement().classList.remove("bubbleHidden");
        }

        hideMarker() {
            let tooltip = this.marker.getTooltip();
            if (tooltip != undefined) {
                tooltip.getElement().classList.add("bubbleHidden");
            }
            this.marker.getElement().classList.add("bubbleHidden");
        }

        formatTooltipValue() {
            let formattedValue = Math.abs(this.count);
            const si = [
                {
                    value: 1,
                    symbol: ""
                },
                {
                    value: 1000,
                    symbol: "k"
                },
                {
                    value: 1E6,
                    symbol: "M"
                },
                {
                    value: 1E9,
                    symbol: "bn"
                },
                {
                    value: 1E12,
                    symbol: "T"
                },
                {
                    value: 1E15,
                    symbol: "P"
                },
                {
                    value: 1E18,
                    symbol: "E"
                }
            ];

            let i;
            for (i = si.length - 1; i > 0; i--) {
                if (formattedValue >= si[i].value) {
                    break;
                }
            }
            formattedValue = Number((this.count / si[i].value).toFixed(0)).toLocaleString() + si[i].symbol;
            return formattedValue;
        }
    }

    class Barchart {
        constructor(field, elements, dataType, emptyFieldLabel, label, perCapitaData, compareOneTotalCount, compareTwoTotalCount, plotLocationQuotient) {
            this.field = field;
            this.elements = elements;
            this.dataType = dataType;
            this.maximum = null;
            this.emptyFieldLabel = emptyFieldLabel;
            this.numberOfTopResultsToShow = 15;
            this.label = label;
            this.perCapitaData = perCapitaData;
            this.perCapitaMultiplier = 1000;
            this.compareOneTotalCount = compareOneTotalCount;
            this.compareTwoTotalCount = compareTwoTotalCount;
            this.plotLocationQuotient = plotLocationQuotient ?? false;
        }

        getMaximumCount() {
            let compareOneCounts, compareTwoCounts;
            const valueField = (this.plotLocationQuotient === true) ? "quotient" : "count";
            compareOneCounts = this.elements.filter(element => element.compareOne).map(element => element.compareOne[valueField]);
            compareTwoCounts = this.elements.filter(element => element.compareTwo).map(element => element.compareTwo[valueField]);
            this.maximum = Math.max(...compareOneCounts.concat(compareTwoCounts));
            return this;
        }

        getMinimumCount() {
            let compareOneCounts, compareTwoCounts;
            const valueField = (this.plotLocationQuotient === true) ? "quotient" : "count";
            compareOneCounts = this.elements.filter(element => element.compareOne).map(element => element.compareOne[valueField]);
            compareTwoCounts = this.elements.filter(element => element.compareTwo).map(element => element.compareTwo[valueField]);
            return Math.min(...compareOneCounts.concat(compareTwoCounts));
        }

        addEnrichmentBarchartClasses() {
            return ` enrichmentBarchart${(this.getMinimumCount() <= 0) ? " negativeValuesPresent" : ""}`;
        }

        createBarchartKey() {
            let barchartKey = coreFunctions.createElementHelper("div", { class: "keyHolder", innerHTML: `<span class='keyElement' data-compare_element='compareOne'><span class='keySquare measured'>&nbsp;</span><span class='keyLabel'><span class='compareGroupTitleElement' data-compare-element='compareOne'>${compare.comparison.compareOne.title}</span></span></span><span class='keyElement' data-compare_element='compareOne'><span class='keyElement' data-compare_element='compareTwo'><span class='keySquare measured'>&nbsp;</span><span class='keyLabel'><span class='compareGroupTitleElement' data-compare-element='compareTwo'>${compare.comparison.compareTwo.title}</span></span></span>` });
            return barchartKey;
        }

        createBarchart(displayAsPercentage) {
            let existingBarchartContentWrapper, barchartContentWrapper, maximumCount, barchartElementsHolder, numberOfTopResultsToShow, barchartExtraElementsHolder, dataType;

            // Remove previously existing barchart if changing data source
            if (existingBarchartContentWrapper = document.querySelector(`.barchartHolder[field='${this.field}'] .barchartContentWrapper`)) {
                document.querySelector(`.barchartHolder[field='${this.field}']`).removeChild(existingBarchartContentWrapper);
            }

            maximumCount = this.maximum;
            dataType = this.dataType;
            numberOfTopResultsToShow = this.numberOfTopResultsToShow;

            barchartContentWrapper = coreFunctions.createElementHelper("div", { class: "barchartContentWrapper", id: `${this.field}ChartContentWrapper`, charttype: "bar" });

            barchartContentWrapper.appendChild(this.createBarchartKey());

            barchartElementsHolder = barchartContentWrapper.appendChild(coreFunctions.createElementHelper("div", { class: `barchartContent${this.dataType == "percentage" ? this.addEnrichmentBarchartClasses() : ""}` })).appendChild(coreFunctions.createElementHelper("ul"));
            barchartExtraElementsHolder = coreFunctions.createElementHelper("ul", { class: "barchartExtras" });

            const plotLocationQuotient = this.plotLocationQuotient;
            this.elements.forEach((element, index) => {
                if (element.thing) {
                    let barchartFragment, barchartLi, compareOneBarchartElement, compareTwoBarchartElement, rticSubsectorSplit;
                    barchartFragment = document.createDocumentFragment();

                    barchartLi = barchartFragment.appendChild(coreFunctions.createElementHelper("li"));
                    // Splits RTIC vertical into constuent elements
                    if (this.field == "RTICSubsectorCounts") {
                        rticSubsectorSplit = element.thing.split(": ");
                        barchartLi.appendChild(coreFunctions.createElementHelper("span", { class: `barLabel labelContainsDescription`, innerHTML: `${rticSubsectorSplit[0]}<span class="sicDescription"><br>${rticSubsectorSplit[1]}</span>`, title: element.thing }));
                    } else {
                        barchartLi.appendChild(coreFunctions.createElementHelper("span", { class: `barLabel${(element.description) ? " labelContainsDescription" : ""}`, innerHTML: `${((element.thing.toString().length) > 0 ? element.thing : this.emptyFieldLabel)}${(element.description) ? `<span class="sicDescription"><br>${element.description}</span>` : ""}`, title: `${((element.thing.toString().length) > 0 ? element.thing : this.emptyFieldLabel)}${(element.description) ? ` - ${element.description}` : ""}` }));
                    }

                    if (element.compareOne) {
                        compareOneBarchartElement = (dataType == "percentage") ? element.compareOne.createPercentageBarchartElement(maximumCount) : element.compareOne.createBarchartElement(maximumCount, this.emptyFieldLabel, this.perCapitaData, this.perCapitaMultiplier, this.compareOneTotalCount, ((displayAsPercentage && displayAsPercentage === true) ? true : false), plotLocationQuotient);
                        barchartLi.appendChild(compareOneBarchartElement);
                    } else {
                        barchartLi.appendChild(this.createEmptyBarchartElement("compareOne", dataType));
                    }
                    if (element.compareTwo) {
                        compareTwoBarchartElement = (dataType == "percentage") ? element.compareTwo.createPercentageBarchartElement(maximumCount) : element.compareTwo.createBarchartElement(maximumCount, this.emptyFieldLabel, this.perCapitaData, this.perCapitaMultiplier, this.compareTwoTotalCount, ((displayAsPercentage && displayAsPercentage === true) ? true : false), plotLocationQuotient);
                        barchartLi.appendChild(compareTwoBarchartElement, dataType);
                    } else {
                        barchartLi.appendChild(this.createEmptyBarchartElement("compareTwo", dataType));
                    }

                    if (index < numberOfTopResultsToShow) {
                        barchartElementsHolder.appendChild(barchartFragment);
                    } else {
                        barchartExtraElementsHolder.appendChild(barchartFragment);
                    }
                }
            });

            barchartContentWrapper.querySelector(".barchartContent").appendChild(barchartExtraElementsHolder);
            document.querySelector(`.barchartHolder[field='${this.field}']`).appendChild(barchartContentWrapper);
            this.addToggleExtraResultsControl();
            document.querySelector(`#${this.field}Widget .widgetTitle`).innerHTML = this.label;
            return this;
        }

        createEmptyBarchartElement(comparisonGroup, dataType) {
            let barHolder, barContainer;
            barHolder = coreFunctions.createElementHelper("span", { class: "barHolder emptyBar" });
            barContainer = barHolder.appendChild(coreFunctions.createElementHelper("span", { class: "barContainer", "data-compare_element": comparisonGroup }));
            barContainer.appendChild(coreFunctions.createElementHelper("span", { class: "bar", "data-compare_element": comparisonGroup, style: `width: 0%`, innerHTML: "&nbsp;" })); // Bar
            barHolder.appendChild(coreFunctions.createElementHelper("span", { class: "barCount", innerHTML: `0${(dataType == "percentage") ? "%" : ""}` })); // Count
            return barHolder;
        }

        totalElements() {
            return this.elements.length;
        }

        addToggleExtraResultsControl() {
            let totalElements = this.totalElements();
            let numberOfTopResultsToShow = this.numberOfTopResultsToShow;
            const barchartObject = this;

            if (totalElements >= numberOfTopResultsToShow) {
                document.querySelector(`.barchartHolder[field='${this.field}'] .barchartContent`).appendChild(coreFunctions.createElementHelper("div", { class: "showExtraResultsControlHolder" })).appendChild(coreFunctions.createElementHelper("button", { class: "actionControl showExtraResultsControl", field: this.field, innerHTML: `<span class="iconRotate">&nbsp;</span><span class="iconMessage">Show ${(totalElements - numberOfTopResultsToShow).toLocaleString()} more values</span>` }, { click: function () { barchartObject.toggleExtraResults(this) } }));
            }
        }

        // Hide or show extra results
        toggleExtraResults(element) {
            // Extra results are currently visible
            if (element.classList.contains("open")) {
                this.hideExtraResults(element);
            }
            // Extra results are not currently visible
            else {
                this.displayExtraResults(element);
            }
        }

        // Display bar chart extra results
        displayExtraResults(element) {
            let textElement = element.querySelector(".iconMessage");
            // Show fields and update text
            element.classList.add("open");
            document.querySelector(`.barchartHolder[field='${this.field}'] .barchartExtras`).classList.add("open");
            setTimeout(function () {
                textElement.innerHTML = "Hide extra values";
            }, 500);
        }

        // Hide extra lines in barchart
        hideExtraResults(element) {
            let textElement = element.querySelector(".iconMessage");
            const barchartObject = this;
            // Remove open classes
            element.classList.remove("open");
            document.querySelector(`.barchartHolder[field='${this.field}'] .barchartExtras`).classList.remove("open");
            // Update text on control
            setTimeout(function () {
                textElement.innerHTML = `Show ${(barchartObject.totalElements() - barchartObject.numberOfTopResultsToShow).toLocaleString()} more values`;
            }, 500);
        }
    }

    class ExploreLists {
        constructor() {
            this.exploreLists = [];
            this.compareOne = {
                activeExploreListID: null
            };
            this.compareTwo = {
                activeExploreListID: null
            };
        }

        getExploreLists() {
            let method, url;
            const exploreListsObject = this;

            method = "GET";
            url = "../api/lists/lists_actions.php?action=getexplorelists";

            const getExploreListsSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    response.exploreLists.forEach(list => exploreListsObject.newExploreList(list.listID, list.listName, list.listCreated, list.listEdited));
                }
                comparison.loadingComplete();
            }

            const getExploreListsError = function () {
                console.log("Error obtaining explore lists");
                comparison.loadingComplete();
            }

            coreFunctions.xhrHelper(method, url, getExploreListsSuccess, getExploreListsError);
        }

        newExploreList(listID, name, created, edited) {
            const exploreList = new ExploreList(listID, name, created, edited).addListElementToLoadExploreList();
            this.exploreLists.push(exploreList);
            return exploreList;
        }

        loadListButtonClick(element) {
            let comparisonGroup = element.dataset.compare_element;
            if (document.querySelector(`#savedListsSelect option[value='${this[comparisonGroup].activeExploreListID}']`)) {
                document.getElementById("savedListsSelect").value = this[comparisonGroup].activeExploreListID;
            }
            document.querySelector("#loadListForm input[name='comparisonGroup']").value = comparisonGroup;
            coreFunctions.showOverlay("loadlist");
        }

        loadExploreListForCompareSubmit(form) {
            document.getElementById("loadListSubmitButton").disabled = true;

            let method, url, input;
            const exploreListsObject = this;

            method = "POST";
            input = new FormData(form);
            url = `../api/explore/explore_actions.php?action=load_compare_list&listid=${form.elements.listID.value}`;

            const loadExploreListSuccess = function (response) {
                const responseParsed = JSON.parse(response);
                exploreListsObject.loadExploreListComplete(responseParsed);
            }

            const loadExploreListError = function () {
                response = {
                    "status": "error",
                    "title": "Error",
                    "message": "Sorry, could not retrieve saved Explore list."
                }
                exploreListsObject.loadExploreListComplete(response);
            }

            coreFunctions.xhrHelper(method, url, loadExploreListSuccess, loadExploreListError, input);
        }

        loadExploreListComplete(response) {
            coreFunctions.hideOverlay(document.getElementById("loadListSubmitButton"));
            document.getElementById("loadListSubmitButton").disabled = false;
            if (response.status = "success") {
                this.processLoadedExploreList(response);
            } else {
                coreFunctions.showStatusMessage(response.title, respons.message);
            }
        }

        processLoadedExploreList(response) {
            let comparisonGroup, exploreListName;
            comparisonGroup = response.comparisonGroup;
            exploreListName = response.exploreList.listName;
            this[comparisonGroup].activeExploreListID = response.exploreList.listID;
            comparison.setExploreListTitleForCompare(comparisonGroup, exploreListName);
            comparison[comparisonGroup].filters.resetAllFilters().processAllStoredFilters(JSON.parse(response.exploreList.filters));

        }
    }

    class ExploreList {
        constructor(listID, name, created, edited) {
            this.listID = listID;
            this.name = name;
            this.created = created;
            this.edited = edited;
            this.filters = null;
            this.companyResetLocked = null;
        }

        addListElementToLoadExploreList() {
            document.getElementById("loadListWarning").classList.add("hidden");
            document.getElementById("loadListForm").classList.remove("hidden");

            document.getElementById("savedListsSelect").appendChild(coreFunctions.createElementHelper("option", { innerHTML: this.name, value: this.listID }));
            return this;
        }
    }

    const comparison = new Comparison;

    return {
        comparison: comparison,
        pageBodyLoad: pageBodyLoad,
        toggleMobileHeaderControls: toggleMobileHeaderControls
    }
}();
